<nav class="sh-tab-navigation">
    <a
        *ngFor="let tab of tabs; let i = index"
        [routerLink]="tab.route"
        [attr.data-index]="i"
        class="sh-tab-navigation__item"
        (click)="onSelect(i)"
        [class.-sh-is-active]="i == activeTab"
    >
        {{ tab.label }}
    </a>
</nav>
